import {Component, computed, inject, input, signal} from '@angular/core';
import {CurrencyPipe, UpperCasePipe} from '@angular/common';
import {IconsComponent} from '../../../../../shared/components/icons/icons.component';
import {ItemImageComponent} from '../../../../../shared/components/item-image/item-image.component';
import {Accordion} from '../../../../../shared/components/accordion/accordion';
import {Hr} from '../../../../../shared/components/hr/hr';
import {ButtonComponent} from '../../../../../shared/components/button/button.component';
import {CompareComponent} from '../../../compare.component';
import {CompareItemBase} from '../../../compare-item.base';
import { ResultsItemDetailsModal } from '../../../../results/components/results-item-details-modal/results-item-details-modal';
import {Spinner} from '../../../../../shared/components/spinner/spinner';
import {Text} from '../../../../../shared/components/text/text';
import {TextArea} from '../../../../../shared/components/text-area/text-area';
import {ICompareItem} from '../../../../../types/ICompareItem';

@Component({
  selector: 'app-compare-item',
  standalone: true,
  imports: [
    IconsComponent,
    UpperCasePipe,
    CurrencyPipe,
    ItemImageComponent,
    Accordion,
    Hr,
    ButtonComponent,
    ResultsItemDetailsModal,
    Spinner,
    TextArea,
  ],
  templateUrl: './compare-item.component.html',
  styleUrl: './compare-item.component.css',
})
export class CompareItemComponent extends CompareItemBase {
  level = input.required<string>();
  item = input.required<ICompareItem>();

  compareComponent = inject(CompareComponent);

  isSelected = computed(() => this.compareComponent.selectedItemId() === this.item().id);
  showDetails = signal<boolean>(false);

  selectItem() {
    this.compareComponent.selectedItemId.set(this.item().id);
  }

  setNotes(notes: string | number) {
    this.resultsStore.updateCompareItem(this.level() as 'good' | 'better' | 'best', {customer_notes: String(notes)});
  }
}
